import { getGridStringOperators } from "@mui/x-data-grid-pro";
import { PendingChip } from "@poseidon/ui/components/RagChip";
import { getDate } from "@poseidon/firebase/timestamp";
import {
  ActionChip,
  ApplicationSummaryActionChip,
  LazyActionChip,
} from "../Action/ActionChip";

export const filterOperators = getGridStringOperators().filter(
  (operator) => operator.value === "equals"
);

export const getActionColumnProperties = (actionName) => ({
  type: "string",
  width: 150,
  filterOperators,
  renderCell: ({ row }) => {
    return (
      <LazyActionChip docRef={`applications/${row.id}/actions/${actionName}`} />
    );
  },
});

export const getDealerApplicationColumnAction = (actionName) => ({
  type: "string",
  width: 150,
  filterOperators,
  renderCell: ({ row }) => {
    const state = row[`action_${actionName}_dealerState`] ?? "pending";
    return <ApplicationSummaryActionChip state={state} />;
  },
});

export const timestampColumn = (props) => ({
  width: 180,
  ...props,
  type: "dateTime",
  valueGetter: ({ value }) => getDate(value),
});

export const dateColumn = ({ emptyText, ...props }) => ({
  width: 100,
  ...props,
  type: "date",
  valueFormatter: ({ value }) =>
    value?.toLocaleDateString("en-GB") ?? emptyText ?? "",
  valueGetter: ({ value }) => getDate(value),
});
